export const ORA_FAMILLE_SEARCH_SUCCES = "ORA_FAMILLE_SEARCH_SUCCES";
export const ORA_FAMILLE_SEARCH_ECHEC = "ORA_FAMILLE_SEARCH_ECHEC";
export const ORA_FAMILLE_SEARCH_REQUETTE = "ORA_FAMILLE_SEARCH_REQUETTE";

export const ORA_FAMILLE_SEARCH_RESET = "ORA_FAMILLE_SEARCH_RESET";

export const ORA_ARTICLE_FAMILLE_SUCCES = "ORA_ARTICLE_FAMILLE_SUCCES";
export const ORA_ARTICLE_FAMILLE_ECHEC = "ORA_ARTICLE_FAMILLE_ECHEC";
export const ORA_ARTICLE_FAMILLE_REQUETTE = "ORA_ARTICLE_FAMILLE_REQUETTE";
